import React, { useState, useRef, useEffect } from "react";
import "../../components/common/common.css";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
import "./homePage.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactTicker } from "@guna81/react-ticker";
import sellmartImageMob from "../../assets/images/banner_576_430.png";
import sellmartImage from "../../assets/images/selsmart_banner.png";
import couponImage from "../../assets/images/coupon_product.png";
import work1Image from "../../assets/images/Sell Used Appliances  file_Get the best offer copy.png";
import MoreIconImage from "../../assets/images/more_icon.png";
import work2Image from "../../assets/images/Sell Used Appliances  file_Doorstep Pickup copy.png";
import work3Image from "../../assets/images/Sell Used Appliances  file_Instant Payment copy 2.png";
import whySelsmartImage from "../../assets/images/why choose us JPEG (2).jpg";
import bulkImage from "../../assets/images/Bulk Pickup Made Easy section image Final PNG.png";
import transparentPricingImage from "../../assets/images/icons why choose us_Transparent Pricing copy.svg";
import groceryImage from "../../assets/images/icons why choose us_As Easy as Grocery Shopping copy.svg";
import fastestImage from "../../assets/images/icons why choose us_Fastest Pickup copy.svg";
import secureImage from "../../assets/images/icons why choose us_Secure Transactions copy.svg";
import trustImage from "../../assets/images/icons why choose us_Trusted Across India copy.svg";
import Footer from "../../components/common/footer";
import Header from "../../components/common/header";
import { useUser } from "../../contexts/userContext";
import excahangeOffer from '../../assets/images/Exchange Offer.png';
import greatDeals from '../../assets/images/Great deals.png';
import partnership from '../../assets/images/partnerships.png';
import sellmartMicrowaveImage from '../../assets/images/microwave.png';
import sellmartWashingMachineImage from '../../assets/images/front load.png';
import sellmartAcImage from '../../assets/images/wndow ac.png';
import SplitAcImage from '../../assets/images/split_ac.png';
import sellmarFridgeImage from '../../assets/images/single door_fridge.png';
import TvImage from '../../assets/images/LCD_LED.png';
import GeyserImage from '../../assets/images/gyser.png';
import TopAppliances from "../../components/common/topAppliances";
import OwlCarouselComponent from "../../components/common/OwlCarouselComponent";
import OurPartners from "../../components/common/ourPartner";
import MediaPartners from "../../components/common/media";
import Feedbacks from "../../components/common/testimonialsPage";
import whatsAppImg from "../../assets/images/whatsapp-new.png"
import JourneySection from "../../components/common/ourJOurneySection";
import SEOContent from "../../components/common/seoContentPage";
import { useCart } from "../../contexts/cartContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TestimonialSlider from "../../components/common/TestimonialSlider";
// const ReactTickerAny: any = ReactTicker;
import sellmartLgImage from '../../assets/images/Frame 975.png';
import sellmartBoschImage from '../../assets/images/Frame 969.png'
import oppoImage from '../../assets/images/Frame 977.png'
import loitImage from '../../assets/images/Frame 976.png'
import whirlpoolImage from '../../assets/images/Frame 97.m1.png'
import signifyImage from '../../assets/images/Frame 9..68.png'

interface Faq {
  faq_id: number;
  faq_question: string;
  faq_answer: string;
}

interface FaqsOnlyProps {
  limit?: number;
  showContactButton?: boolean;
  showHeading?: boolean;
}

type Banner = {
  img_url: string;
  link_url: string;
  mobile_img_url:string;
 
};

const appliancesheavyItems = [
  {
    slug: "item-1",
    image: sellmartLgImage,
    name: "Washing Machine",
    price: "15,000",
  },
  {
    slug: "item-2",
    image: sellmartBoschImage,
    name: "Refrigerator",
    price: "25,000",
  },
  {
    slug: "item-3",
    image: oppoImage,
    name: "Microwave Oven",
    price: "20,000",
  },
  {
    slug: "item-3",
    image: whirlpoolImage,
    name: "Whirlpool Machine",
    price: "30,000",
  },
  // Add more appliances as needed
];

const handleLinkClick = () => {
  // console.log("Link clicked!");
  // You can implement your click handling logic here
};



const FaqsOnly: React.FC<FaqsOnlyProps> = ({
  limit,
  showContactButton,
  showHeading,
}) => {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [expandedFaqId, setExpandedFaqId] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;

  useEffect(() => {
    sessionStorage.removeItem("mobileNumber");
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    // sessionStorage.removeItem('productId');

    const fetchFaqs = async () => {
      try {
        const response = await fetch(`${backendUrl}api/v2/All-Faqs`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json"
      
            },
            credentials: "include",
            mode:"cors"               
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const flattenedFaqs = Object.values(data.data).flat() as Faq[]; // Adjusted to match expected API response
        setFaqs(flattenedFaqs);
      } catch (error) {
        //console.error("Error fetching FAQs:", error);
        setError("Unable to fetch FAQs. Please try again later.");
      }
    };

    fetchFaqs();
  }, [backendUrl]);



  const handleFaqClick = (faqId: number) => {
    setExpandedFaqId(expandedFaqId === faqId ? null : faqId);
  };

  const displayedFaqs = limit ? faqs.slice(0, limit) : faqs;

  return (
    <main className="container">
      <div className="faq-content">
        {/* Render the heading only if showHeading is true */}
        {showHeading && <h1>FAQS</h1>}

        {/* Show error messages if there's an error */}
        {error && <p className="error-message">{error}</p>}

        {/* Render FAQ items */}
        <div className="faq-items">
          {displayedFaqs.map((faq: any) => (
            <div key={faq.faq_id} className={`faq-item ${expandedFaqId === faq.faq_id ? 'highlighted' : ''}`}>
              <div
                className="faq-question"
                onClick={() => handleFaqClick(faq.faq_id)}
              >
                <span>{faq?.question}</span>
                <button className="faq-toggle-button">
                  {expandedFaqId === faq.faq_id ? "-" : "+"}
                </button>
              </div>
              {expandedFaqId === faq.faq_id && (
      <div className="faq-answer">
        {faq.answer ? (
          <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
        ) : (
          <p>{faq.answer}</p>
        )}
      </div>
    )}
            </div>
          ))}
        </div>

        {/* Optional Contact Button */}
      </div>
    </main>
  );
};
const HomePage = () => {
  const [feedbackList, setFeedbackList] = useState<any[]>([]);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [mobileNo, setMobileNo] = useState('');
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [expandedFaqId, setExpandedFaqId] = useState<number | null>(null);
  const [seoContent, setSeoContent] = useState<string | null>(null);
  const [tickerContent, setTickerContent] = useState<string | null>(null);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [banners, setBanners] = useState<Banner[]>([]);
  const [popupMsg, setPopupMsg] = useState("");
  const [imageLoadingStates, setImageLoadingStates] = useState<{ [key: number]: boolean }>(
    {}
  );
  const location = useLocation();
  // const [loading, setLoading] = useState<boolean>(true);
  const [loadingg, setLoadingg] = useState(true);
  const [loading, setLoading] = useState(true);
  const query = new URLSearchParams(location.search);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const img_url = process.env.REACT_IMG_URL;
  const {
    city_name,
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    globalUtmQueryRef
  } = useUser();
  const { fetchCartQuantity,cartQuantity,setCartQuantity,handleQuantity } = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId,fetchCsrfToken  } = useUser();
  const navigate = useNavigate();
  const handleBulkPickups = () => {
    navigate('/bulk-pickup');
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const utmSource = query.get('utm_source');
  const utmQuery = location.state?.utmQuery
  let utmQueryRef:any = useRef("")
  function generateUtmSessionId(length = 24) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    return result;
  }
  const handleReadMoreClick = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleFaqs = () => {
    setGlobalSearchTerm("");
    window.open('/faq', '_blank');
    window.scrollTo({ top: 0, behavior: 'smooth' });
}


const handleImageLoad = (index: number) => {
  setImageLoadingStates((prevStates) => ({
    ...prevStates,
    [index]: false,
  }));
};

const handleImageError = (index: number) => {
  setImageLoadingStates((prevStates) => ({
    ...prevStates,
    [index]: false,
  }));
};

const handleImageeLoad = () => {
  setLoadingg(false); // Set loading to false once images are loaded
};


const fetchSeoMetaDetails = async () => {
  try {
      const code = 'home_page'
      const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"          
        }
      );
      if (!response.ok) throw new Error('Failed to fetch categories');
      const data = await response.json();
      await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
  } catch (error) {
      //console.error('Error fetching categories:', error);
  }
};

const changeTitleAndMetaTags = async (
  title: string,
  metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
) => {
  try {
      // Update the document title
      if (title) {
          document.title = title;
      } else {
          document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      }

      // Update or create meta tags
      Object.keys(metaTags).forEach((metaName) => {
          const metaTag = document.querySelector(`meta[name="${metaName}"]`);
          if (metaTag) {
              // Update existing meta tag
              metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
          } else {
              // Create new meta tag if it doesn't exist
              const newMetaTag = document.createElement('meta');
              newMetaTag.name = metaName;
              newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
              document.head.appendChild(newMetaTag);
          }
      });

      // Cleanup function to reset the title and meta tags when unmounting
      return () => {
          document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
          Object.keys(metaTags).forEach((metaName) => {
              const metaTag = document.querySelector(`meta[name="${metaName}"]`);
              if (metaTag) {
                  metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
              }
          });
      };
  } catch (error) {
      //console.error("Error updating title and meta tags:", error);
  }
};


const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties; button: React.CSSProperties  } = {
  overlay: {
      position: 'fixed', // Valid string for 'position'
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  },
  modal: {
      backgroundColor: 'white',
      padding: '40px',
      borderRadius: '8px',
      textAlign: 'center',
  },
  button: {
      padding: '5px',
      margin: '8px',
  }
};

  useEffect(() => {
    fetchTickerData()
    fetchSeoMetaDetails()
    if (utmSource) {
      // console.log("utmSource inside")
    // Usage
    const utmSessionId = generateUtmSessionId(); // Simple session ID generator
    // console.log("00000000000", utmSessionId, query.toString());
    setUtmSessionId(utmSessionId);
    // query.set('utm_session_id', utmSessionId); // Add utm_session_id to query
      // console.log("query set utm_session_id", query.toString());
      let utmquerydata = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
        /&/g,
        ":<>:"
      )}`;
    utmQueryRef.current = 
    globalUtmQueryRef.current = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
      /&/g,
      ":<>:"
    )}`;
    localStorage.setItem(
      "utm_query_data",
      `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
        /&/g,
        ":<>:"
      )}`
    );
    // console.log(
    //   "query after setting utm_session_id",
    //   utmQueryRef.current
    //   );
      createUtmTrackingSaveService(utmquerydata);
  } else {
    if (utmQuery) {
      // console.log("utm_query set in add to cart", utmQuery);
      utmQueryRef.current = utmQuery;
        globalUtmQueryRef.current = utmQuery;
        createUtmTrackingSaveService(utmQuery);
    }
  }
    
    const wrapper = wrapperRef.current;
    fetchSEOContent()
    if (!wrapper) return;

    // Duplicate content for seamless rotation
    wrapper.innerHTML += wrapper.innerHTML;

    let scrollPosition = 0; // Tracks the current scroll position
    const originalWidth = wrapper.scrollWidth / 2; // Half the total width (original content)

    const moveTicker = () => {
        if (!wrapper) return;

        scrollPosition += 1; // Move 1px to the left
        if (scrollPosition >= originalWidth) {
            scrollPosition = 0; // Reset to start for seamless loop
        }

        wrapper.style.transform = `translateX(-${scrollPosition}px)`;
        requestAnimationFrame(moveTicker); // Recursively call for smooth movement
    };

    requestAnimationFrame(moveTicker); // Start the ticker animation

    return () => {
        // Cleanup when the component is unmounted
        wrapper.style.transform = `translateX(0px)`;
    };
}, []);

const createUtmTrackingSaveService = async (utmData:any) => {
  try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const ip_address = ipData.ip;
      const updatedUtmData = new URLSearchParams(utmData);
updatedUtmData.append("ip_address", ip_address);
    const response = await fetch(
      `${backendUrl}${version}utm-campaign-tracking?${updatedUtmData.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        mode:"cors"  
      }
      );
    const data = await response.json();
  } catch (err: any) {
    setError(err.message);
  } finally {
  }
}

  
// useEffect(() => {
//   const autoScroll = setInterval(() => {
//       handleItemScroll('right'); // Automatically scroll to the right every 10 seconds
//   }, 10000);

  // Cleanup interval on component unmount
//   return () => clearInterval(autoScroll);
// }, []);

const handleClickAddToCart = (slug:any) => {
navigate(`${slug}`)
window.scrollTo({ top: 0, behavior: 'smooth' })
}

// Automatically shift items to the right every 10 seconds
// useEffect(() => {
//   const interval = setInterval(() => {
//       handleItemScroll('right');
//   }, 10000); // Every 10 seconds, shift one item

//   return () => clearInterval(interval); // Clean up interval on unmount
// }, []);


const fetchSEOContent = async () => {
  try {
    const response = await fetch(`${backendUrl}${version}seo-content/home_page_seo`, 
      {  method: 'GET',
        headers:{
          // Accept:'aplication/json',
          "Content-Type": "application/json"
  
        },
                   credentials: "include",
                        mode:"cors"
      });
    const data = await response.json();
    setSeoContent(data.data);
  } catch (err: any) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const fetchBanners = async () => {
    try {
      const response = await fetch(`${backendUrl}${version}home-banner/home_page_banner`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"         
        });
    const data = await response.json();
    setBanners(data.data);
    } catch (error) {
      //console.error("Error fetching banners:", error);
    }
  };

  fetchBanners();
}, []);

const getMobileImagePath = (url: string) => {
  const basePath = "/mobile/";
  const parts = url.split("homepage/");
  if (parts.length > 1) {
    return `${parts[0]}homepage${basePath}${parts[1]}`;
  }
  return url;
};


  const handleSellMoreClick = () => {
    navigate('/sell-used-appliances')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const rotateFeedbackList = () => {
    setFeedbackList((prevList) => {
      // Remove the first item and append it to the end
      const rotatedList = [...prevList];
      const firstItem = rotatedList.shift();
      if (firstItem) {
        rotatedList.push(firstItem);
      }
      return rotatedList;
    });
  };

  const handleFaqClick = (faqId: number) => {
    setExpandedFaqId(expandedFaqId === faqId ? null : faqId);
  };

  // useEffect(() => {
  //   fetchTickerData()
  //   const autoScroll = setInterval(() => {
  //     rotateFeedbackList(); // Rotate the feedback list every 10 seconds
  //   }, 10000);

  //   // Cleanup interval on unmount
  //   return () => clearInterval(autoScroll);
  // }, []);

  const fetchFeedbackList = async () => {
    try {
      const response = await fetch(`${backendUrl}${version}All-feedbacks`, 
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"            
        }
    );
      const data = await response.json();
      //console.log("Fetched Data:", data); // Log the data to inspect its structure

      if (Array.isArray(data.data)) {
        const flattenedData = data.data.flat();
        setFeedbackList(flattenedData);
      } else {
        // console.warn("Expected data to be an array but received:", data);
        setFeedbackList([]); // Default to empty array if not an array
      }
    } catch (error) {
      //console.error("Error fetching feedback data:", error);
      setFeedbackList([]); // Default to empty array in case of error
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    sessionStorage.removeItem('productId');
    fetchTickerData()
    fetchFeedbackList();
  }, []);

  useEffect(() => {
    fetchFeedbackList();
    fetchTickerData()
    
  }, []);
  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;
  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
    setMobileNo(value);
    setShowError(value.length > 0 && value.length < 10);

    // Clear the error message when the user starts typing
    if (error) {
      setError(null);
    }
  };

  const ticker_code = 'home_page_ticker'

  const fetchTickerData = async () => {
    try {
      const response = await fetch(`${backendUrl}${version}home-content/${ticker_code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"    
        });
      const data = await response.json();
      //console.log("Fetched Data ticker:", data.data); // Log the data to inspect its structure

      if (data.data) {
        
        setTickerContent(data.data)
      } else {
        // console.warn("Expected data to be an array but received:", data);
        setFeedbackList([]); // Default to empty array if not an array
      }
    } catch (error) {
      //console.error("Error fetching feedback data:", error);
      setFeedbackList([]); // Default to empty array in case of error
    }
  };

//   useEffect(() => {
//     if (wrapperRef.current) {
//         const contentWidth = wrapperRef.current.scrollWidth;
//         wrapperRef.current.style.animationDuration = `${contentWidth / 50}s`; // Adjust speed
//     }
// }, [tickerContent]);

// async function fetchCsrfToken() {
//   const response = await fetch(`${backendUrl}api/v1/csrf-token`,
//     {  method: 'GET',
//       headers:{
//         // Accept:'aplication/json',
//         "Content-Type": "application/json",

//       },
//       //       
//     }
//   );
//   const data = await response.json();
//   return data.csrfToken;
// }



  const handleSubscribe = async () => {
    if (mobileNo.length !== 10) {
      setError('Mobile number must be 10 digits long.');
      return;
    }
    
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ mobile_no: mobileNo }),
        
      });

      if (response.ok) {
        const data = await response.json();
        // alert('Subscription successful!');
        setShowModalInfo(true)
        setPopupMsg(data.result)
        //console.log('Response:', data.result);
      } else {
        // alert('Subscription failed. Please try again.');
        //console.error('Error:', response.statusText);
      }
    } catch (error) {
      //console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  const handleCloseModalClick = () => {
    setError("");
    setMobileNo('')
    setShowModalInfo(false); // Close the modal

  };

 

//console.log("ticker-------",tickerContent)

  return (
    <div className='home-page'>
      <Header />
      <main className="main-content">
      <section>
        <div className="scroll">
          {/* <div>
          {tickerContent} <span>{tickerContent} </span>{" "}
          {tickerContent} <span> {tickerContent} </span>
          </div>
          <div>
          {tickerContent} <span> {tickerContent} </span>{" "}
          {tickerContent} <span> {tickerContent} </span>
          </div> */}
        </div>
      </section>
{/* {tickerContent ? ( 
  <div className="ticker-container" >
      <div className="container">
            <div className="ticker-wrapper" ref={wrapperRef} >
                <div className="ticker-text" >{tickerContent}</div>
                <div className="ticker-text" >{tickerContent}</div>
                <div className="ticker-text" >{tickerContent}</div>
                <div className="ticker-text" >{tickerContent}</div>
                <div className="ticker-text" >{tickerContent}</div>
                <div className="ticker-text" >{tickerContent}</div>
            </div>
            </div>

        </div>):(
           null 
        )}  */}

{tickerContent ? (
  <div className="ticker-container">
    <div className="container">
      <div className="ticker-wrapper" ref={wrapperRef}>
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
        <div 
          className="ticker-text" 
          dangerouslySetInnerHTML={{ __html: tickerContent }} 
        />
      </div>
    </div>
  </div>
) : null}

{/* <div className="ticker-container">
            <div className="ticker-wrapper" ref={wrapperRef}>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
                <div className="ticker-text">Selsmart! New Year Offer 2025d</div>
            </div>
        </div> */}

<section className="slide_banner">
      <div className="container-fluid p-0">
        <div className="row">
          <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel" data-bs-touch="true">
            <div className="carousel-indicators">
              {banners.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide-to={index}
                  className={index === 0 ? "active" : ""}
                  aria-current={index === 0 ? "true" : undefined}
                  aria-label={`Slide ${index + 1}`}
                ></button>
              ))}
            </div>
            <div className="carousel-inner p-0">
              {banners.map((banner, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                  <div className="row banner_wrap">
                    <div className="col-12 image_slide justify-content-center d-flex">
                      {imageLoadingStates[index] !== false && (
                        <div className="loaderr-container">
                          <div className="loaderr"></div>
                        </div>
                      )}
                      {/* Web Image */}
                      <img
                        src={banner.img_url}
                        className="web_img d-block w-100"
                        alt="banner"
                        style={{
                          display: imageLoadingStates[index] === false ? "block" : "none",
                        }}
                        onLoad={() => handleImageLoad(index)}
                        onError={() => handleImageError(index)}
                        onClick={() => banner.link_url && window.open(banner.link_url, "_blank")}
                      />
                      {/* Mobile Image */}
                      <img
                        src={banner.mobile_img_url}
                        className="mob_img d-block w-100"
                        alt="banner"
                        style={{
                          display: imageLoadingStates[index] === false ? "block" : "none",
                        }}
                        onLoad={() => handleImageLoad(index)}
                        onError={() => handleImageError(index)}
                        onClick={() => banner.link_url && window.open(banner.link_url, "_blank")}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

        
    <OwlCarouselComponent/>
        {/* <TopAppliances /> */}
        {/* <section className="featured hotdeals ">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="featuredProduct">
                  <h2 className="headingText">Hot Deals</h2>
                  <h5 className="topText">Exciting offers for more value </h5>
                </div>
                <div className="featured_pro_autoplay">
                  <div className="owl-carousel hotdeals owl-theme">
                    <div className="item">
                      <div className="fetur_pro_img">
                        <img src={excahangeOffer} alt="Refurbished Device Offers" />
                      </div>
                      <div className="fetur_pro_img_description">
                        <p className="fe_pro_name">Exchange<br className="no_mob" /> Offers</p>
                       
                        <a ><img src={MoreIconImage} alt='More-icon'/></a>
                      </div>
                    </div>
                    <div className="item">
                      <div className="fetur_pro_img">
                        <img src={greatDeals} alt="Repair Offers" />
                      </div>
                      <div className="fetur_pro_img_description">
                        
                        <p className="fe_pro_name">Great<br className="no_mob" /> Deals</p>
                        <a ><img src={MoreIconImage} alt='More-icon'/></a>
                      </div>
                    </div>
                    <div className="item">
                      <div className="fetur_pro_img">
                        <img src={partnership} alt="Buyback Offers" />
                      </div>
                      <div className="fetur_pro_img_description">
                     
                        <p className="fe_pro_name">Partnership<br className="no_mob" /> Offers</p>
                        <a ><img src={MoreIconImage} alt='More-icon'/></a>

                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>


          </div>
        </section> */}
        <section className="howWorks">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="featuredProduct">
                  <h2 className="headingText">
                  Sell Used Electronics in 3 Simple Steps
                  </h2>
                  <h5 className="topText">
                    India’s largest online platform for selling used electronics
                  </h5>
                </div>
                <div className="workCard row ">
                  <div className=" col col1">
                    <div className="works col-12">
                      <img src={work1Image} alt="" />
                      <h3 className="workHeading">Get the Best Offer</h3>
                      <p className="workText">
                        Find out your product's value in just a few clicks
                      </p>
                    </div>
                  </div>
                  <div className=" col col2">
                    <div className="works col-12">
                      <img src={work2Image} alt="" />
                      <h3 className="workHeading">Doorstep Pickup</h3>
                      <p className="workText">
                        Schedule now, and we’ll pick up your product within
                        24-48 hours
                      </p>
                    </div>
                  </div>
                  <div className=" col col3">
                    <div className="works col-12">
                      <img src={work3Image} alt="" />
                      <h3 className="workHeading">Instant Payment</h3>
                      <p className="workText">
                        Receive your payment online immediately
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <OurPartners /> */}
        <TestimonialSlider/>

        <section className="eco-friendly">
          <div className="container">
            <div className="eco-right">
              <div className="whyChoose text-center">
                <h2 className="headingText">Why Choose Selsmart?</h2>
                <h5 className="topText">
                Eco-Friendly Recycling by India’s largest E-waste Recycler
                </h5>
              </div>
              <div className="eco-info">
                <div className="whyselsmart col-10 d-flex mx-auto align-items-center">
                  <div className="eco-left col-6">
                    <img
                      src={whySelsmartImage}
                      alt="Product Image"
                      className="eco-img"
                    />
                  </div>
                  <div className="eco-items col-6">
                    <div className="eco-item">
                      <img src={transparentPricingImage} alt="Heart Icon" />
                      <div className="eco-text">
                        <h3>Transparent Pricing</h3>
                        <p>No hidden charges—what you see is what you get</p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={groceryImage} alt="Heart Icon" />
                      <div className="eco-text">
                        <h3>As Easy as Grocery Shopping</h3>
                        <p>
                          Experience a simple way to sell your used electronics
                        </p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={fastestImage} alt="Recycle Icon" />
                      <div className="eco-text">
                        <h3>Fastest Pickup</h3>
                        <p>
                          Get your old appliance picked up within 24-48 hours
                        </p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={secureImage} alt="Recycle Icon" />
                      <div className="eco-text">
                        <h3>Secure Transactions</h3>
                        <p>Payments are processed securely and reliably</p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={trustImage} alt="Recycle Icon" />
                      <div className="eco-text">
                        <h3>Trusted Across India</h3>
                        <p>
                          With reliable service and satisfied customers
                          nationwide
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <JourneySection />

        <Feedbacks />

        <section className="bulk-pickup">
          <div className="container">
            <div className="col-md-10 col-lg-10 mx-auto">
              <div className="row">
                <div className="col-md-6 col-lg-6 pickup">
                  <h2 className="pickupHeading">Bulk Pickup Made Easy</h2>
                  <p className="pickupContent">
                    Partner with Selsmart for efficient bulk appliance pickups
                    that simplify responsible recycling.
                  </p>
                  <p className="pickupContent">
                    Housing Societies | Institutions | Offices
                  </p>
                  <button className="bulkPickupBtn" onClick={handleBulkPickups}>
                  Bulk Pickup Request
                  </button>
                </div>
                <div className="col-md-6 col-lg-6  pickupImg">
                  <img src={bulkImage} alt="bulkpickup" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="faqs-homepage">
          <div className="text-center faqHome">
            <h2 className="headingTextFaq">FAQs</h2>
          </div>

          {/* Render FAQs without heading */}
          <FaqsOnly limit={5} showContactButton={true} showHeading={false} />

          <div className="col-12 text-center">
            <a className="v_all d-inline-block" onClick={handleFaqs}>
              View All
            </a>
          </div>
        </section>

        <MediaPartners />

        <section className="bulk-pickup Subscribe_news_letter ">
          <div className="container">
            <div className="col-md-10 col-lg-10 mx-auto">
              <h2 className="pickupHeading text-center">
               Stay Updated With Selsmart
              </h2>
              <div className="row">
                <div className=" col-md-12 col-lg-8 pickup text-center mx-auto">
                  <p className="pickupContent">
                    Sign up for free to receive updates, tips, and the latest offers from Selsmart via WhatsApp!

                  </p>

                  <p className="pickupContent">
                    Rest assured; we won’t spam you with messages :)
                  </p>
                  <div className="subscribe-container">
                    <div className="newsletter">
                      <input
                        type="text"
                        className="subscribe-input"
                        placeholder="Enter your number"
                        aria-label="Mobile Number"
                        value={mobileNo}
                        maxLength={10}
                        onChange={handleChange} // Call your handleChange function here
                      />


                      <button className="subscribe-button" onClick={handleSubscribe} > <i className="fab fa-whatsapp" style={{ fontSize: '24px', color: '#fff' }}></i>
                      </button>

                    </div>
                    {error && <p className="error-message">{error}</p>}
                    {showError && <p className="error-message-home">10 digits required</p>}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>

        {showModalInfo && (
  <div className='popup_cart' style={modalStyles.overlay}>
  <div style={modalStyles.modal}>
      {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
      <p className="cart-empty-msg">{popupMsg}</p>
      <button className="cart-empty-button" onClick={handleCloseModalClick}>Got it</button>
  </div>
</div>
              
            )}

        <div className="container">
    <div className='seo-content'>{seoContent}</div>
    </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
